import Vue from 'vue'

Vue.component('vnode', {
  functional: true,
  render (h, context) {
    return context.props.node
  },
})

// Register all components from components folder
function registerAllComponents (req) {
  req.keys().forEach(moduleName => {
    // trim `./` and `.vue`: 'current-saldo.vue' => 'current-saldo'
    var componentName = moduleName.slice(2, -4)
    Vue.component(componentName, req(moduleName).default)
  })
}

registerAllComponents(require.context('./components/', /* useSubdirectories = */false, /\.vue$/))



// WEBPACK FOOTER //
// ./resources/assets/js/components.js